export const STIPULATION_TYPES = Object.freeze({
  CERTIFICACION_ASISTENTE: 22
});

export default STIPULATION_TYPES;